import React from 'react';
import './styles.css';

const Module10 = () => {
  return (

<div className="" style={{backgroundColor: "#1E1C1C"}}>
  {/* Div para o texto superior */}
  <div className="text-center py-2 special-font text-white">
        
      </div>
      
      {/* Div para o conteúdo com logomarca e texto lado a lado */}
      <div className="container d-flex flex-column flex-sm-row justify-content-center align-items-center py-2">
        {/* Logomarca */}
        <div className="mx-5">
          <img src="Logotipo 1-fundopreto2.png" alt="IMO Investimentos" style={{ height: '100px' }} />
        </div>

        {/* Texto ao lado da logomarca */}
        <div className="navbar-text text-white col-8 col-sm-3 special-font d-flex align-items-center" style={{fontSize: "22px"}}>
          <p className="m-0">Invista com Segurança e <span className="highlight">Alta Rentabilidade</span> no mercado imobiliário europeu</p>
        </div>
      </div>
      <h6 className="text-white text-center mt-4 special-font" style={{letterSpacing: '1.5px'}}>O FUTURO DO INVESTIMENTO IMOBILIÁRIO COMEÇA AQUI !!!!</h6> {/* Alterado de h4 para h5 */}
      <p className="text-center mt-4" style={{fontSize: "12px", color: "#9e9e9e"}}>IMO Investimentos e Molteplici Imóveis 2025 | Todos os direitos reservados
</p> {/* Alterado de h4 para h5 */}
</div>


  
  );
};

export default Module10;
